import { mkTag, type Tag, type TagProps } from './tagsTypes';

export function transformTagToRequestData(tag: Tag | TagProps) {
  return {
    id: tag.id,
    name: tag.name,
    isDeleted: tag.isDeleted,
    description: tag.description,
    type: tag.type,
    copyNumber: tag.copyNumber,
    isHidden: tag.isHidden,
    clientId: tag.clientId,
    createdAt: tag.createdAt,
  };
}

export function transformResponseToTags(response?: { data?: { resources?: TagProps[] } } | null) {
  return response?.data?.resources?.map((data) =>
    mkTag({
      id: data.id,
      name: data.name,
      isDeleted: data.isDeleted,
      description: data.description,
      type: data.type,
      copyNumber: data.copyNumber,
      isHidden: data.isHidden,
      clientId: data.clientId,
      createdAt: data.createdAt,
    }),
  );
}

export function transformTagsToRequestData(tags: Array<Tag | TagProps>) {
  const resources: TagProps[] = [];

  tags.forEach((tag) => {
    resources.push(transformTagToRequestData(tag));
  });

  return { resources };
}
